import axios from 'axios';
import tokenService from './token.service';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = tokenService.getLocalAccessToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token; // for Spring Boot back-end
      // config.headers["x-access-token"] = token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const cdnInstance = axios.create({
  baseURL: process.env.REACT_APP_CDN_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
  },
});

cdnInstance.interceptors.request.use(
  (config) => {
    const token = tokenService.getLocalAccessToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token; // for Spring Boot back-end
      // config.headers["x-access-token"] = token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// instance.interceptors.response.use(
//   (res) => {
//     return res;
//   },
//   async (err) => {
//     const originalConfig = err.config;
//     console.log('origin.config.url', originalConfig.url);
//     if (originalConfig.url !== '/admin/login' && err.response) {
//       // Access Token was expired
//       if (err.response.status === 401 && !originalConfig._retry) {
//         originalConfig._retry = true;

//         try {
//           const refreshToken = tokenService.getLocalRefreshToken();
//           if (!refreshToken) throw new Error('Please login again!');
//           const rs = await instance.post('/auth/refreshtoken', {
//             refreshToken: tokenService.getLocalRefreshToken(),
//           });

//           const { accessToken } = rs.data;
//           tokenService.setLocalAccessToken(accessToken);

//           return instance(originalConfig);
//         } catch (_error) {
//           return Promise.reject(_error);
//         }
//       }
//     }

//     return Promise.reject(err);
//   }
// );

export default instance;
